import * as React from 'react';
import Button from '@idp/ui-components/components/atoms/Button/Button';
import { ButtonType, IconPosition, ButtonColor } from '@idp/ui-components/components/atoms/Button/ButtonProps';
import getTestId from '@idp/ui-components/utils';
import * as icons from '../../../styles/att-icons-common.scss';
import * as styles from './PriceBar.scss';
var PriceBarService = /** @class */ (function () {
    function PriceBarService() {
    }
    PriceBarService.renderButton = function (props, buttonData, buttonEvents) {
        var buttonText = buttonData.text;
        var isApplePay = false;
        if (buttonData.text && buttonData.text.toLowerCase().indexOf('apple pay') > -1) {
            buttonText = buttonData.text.substring(0, buttonData.text.toLowerCase().indexOf('apple pay'));
            isApplePay = true;
            buttonData.color = ButtonColor.WHITE;
        }
        return React.createElement(Button, { testId: getTestId(props.testId, 'Button'), data: { text: buttonText, disabled: !buttonData.enabled }, events: buttonEvents, options: {
                className: isApplePay ? styles.applePay : '',
                color: buttonData.color,
                iconFont: isApplePay ? icons.attIconCommon : undefined,
                iconName: isApplePay ? icons.attIconCommonApplePayButton : undefined,
                iconPosition: isApplePay ? IconPosition.RIGHT : undefined,
                showLoader: props && props.data && props.data.buttonData
                    && props.data.buttonData.showLoader,
                type: ButtonType.PRIMARY,
            } });
    };
    return PriceBarService;
}());
export default PriceBarService;
//# sourceMappingURL=PriceBarService.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/components/PriceBar/PriceBarSub/PriceBarService.js
// module id = 410
// module chunks = 8